// extracted by mini-css-extract-plugin
export default {"university":"School_university__p+3mq","content":"School_content__IejTa","period":"School_period__sdKib"};